import { render } from "./GarageGateSetting.vue?vue&type=template&id=084d6d76"
import script from "./GarageGateSetting.vue?vue&type=script&lang=js"
export * from "./GarageGateSetting.vue?vue&type=script&lang=js"

import "./GarageGateSetting.vue?vue&type=style&index=0&id=084d6d76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__